


import mammoth from "mammoth";
import pdfToText from "react-pdftotext";

export const ExtractDocumentText = async (file) => {
  const fileType = file.type;

  try {
    if (fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
      // DOCX
      const arrayBuffer = await file.arrayBuffer();
      const { value: text } = await mammoth.extractRawText({ arrayBuffer });
      return text;
    } else if (fileType === "application/pdf") {
      // PDF
      const text = await pdfToText(file);
      return text;
    } else {
      throw new Error("Unsupported file type. Please upload a PDF or DOCX file.");
    }
  } catch (err) {
    console.error("Error extracting file text:", err);
    return "";
  }
};

